import { render, staticRenderFns } from "./ppd.vue?vue&type=template&id=06c1f25f&"
import script from "./ppd.vue?vue&type=script&lang=js&"
export * from "./ppd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports